// Selector de país (bandera + prefijo) limitado a las regiones habilitadas para SMS.
// Emite el número en formato internacional E.164, ej: "+58XXXXXXXXXX".

import { useTranslation } from "react-i18next";


export const PHONE_COUNTRIES = [
  { code: "VE", dial: "+58", flag: "🇻🇪", name: "Venezuela" },
  { code: "GB", dial: "+44", flag: "🇬🇧", name: "Reino Unido" },
  { code: "US", dial: "+1", flag: "🇺🇸", name: "Estados Unidos" },
  { code: "ES", dial: "+34", flag: "🇪🇸", name: "España" },
  { code: "PT", dial: "+351", flag: "🇵🇹", name: "Portugal" },
];

const DEFAULT_DIAL = "+58";
// Coincidencia por prefijo más largo primero (+351 antes que +34, etc.)
const BY_LENGTH = [...PHONE_COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);

const parse = (value) => {
  const v = String(value || "").replace(/\s+/g, "");
  const match = BY_LENGTH.find((c) => v.startsWith(c.dial));
  if (match) return { dial: match.dial, national: v.slice(match.dial.length).replace(/\D/g, "") };
  return { dial: DEFAULT_DIAL, national: v.replace(/\D/g, "") };
};

export function PhoneInput({ value, onChange, testid, placeholder, className = "", disabled = false }) {
  const { t } = useTranslation();
  const { dial, national } = parse(value);

  const selectCountry = (newDial) => onChange(`${newDial}${national}`);
  const setNational = (raw) => onChange(`${dial}${raw.replace(/\D/g, "")}`);

  const selectCls =
    "min-h-[48px] rounded-sm border border-neutral-300 bg-white px-2 text-base focus:border-[#0066CC] focus:ring-1 focus:ring-[#0066CC] outline-none shrink-0";

  return (
    <div className={`flex gap-2 ${className}`}>
      <select
        data-testid={testid ? `${testid}-country` : undefined}
        value={dial}
        onChange={(e) => selectCountry(e.target.value)}
        disabled={disabled}
        aria-label={t("phone.countryLabel")}
        className={selectCls}
      >
        {PHONE_COUNTRIES.map((c) => (
          <option key={c.code} value={c.dial}>
            {c.flag} {c.dial}
          </option>
        ))}
      </select>
      <input
        data-testid={testid}
        type="tel"
        inputMode="tel"
        value={national}
        onChange={(e) => setNational(e.target.value)}
        placeholder={placeholder || t("phone.numberPlaceholder")}
        disabled={disabled}
        className="w-full min-h-[48px] rounded-sm border border-neutral-300 bg-white px-3 text-base focus:border-[#0066CC] focus:ring-1 focus:ring-[#0066CC] outline-none"
      />
    </div>
  );
}
